import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TokenDAO {
  private TOKEN_KEY = "token";

  /**
   * Saves the token.
   * @param token
   */
  save(token: string): void {
    window.localStorage.setItem(this.TOKEN_KEY, token);
  }

  /**
   * Gets the saved token.
   * @returns the saved token or null if there is no saved token.
   */
  get(): string | null {
    const token = window.localStorage.getItem(this.TOKEN_KEY);
    if (token == null) {
      return null;
    }
    return token;
  }

  /**
   * Removes the saved token.
   */
  remove() {
    window.localStorage.removeItem(this.TOKEN_KEY);
  }
}
